import { fetchQuery } from 'react-relay';
import { Environment } from 'relay-runtime';
import { hasValidUserSessionGeoInfo, setUserSessionGeoInfo } from './regionalInfoHelpers';
import { userGeoInfoQuery } from './userGeoInfoQuery';
import { userGeoInfoQuery as GeoInfoQueryType } from './__generated__/userGeoInfoQuery.graphql';

const setUserRegionalInfo = async ({
    relayEnv,
    cookieDomain,
    hasRegionsCookieValue,
}: {
    relayEnv: Environment;
    cookieDomain: string;
    hasRegionsCookieValue: boolean;
}): Promise<void> => {
    if (!hasValidUserSessionGeoInfo() || !hasRegionsCookieValue) {
        const data = await fetchQuery<GeoInfoQueryType>(relayEnv, userGeoInfoQuery, {
            cookieDomain: !hasRegionsCookieValue ? cookieDomain : '',
        });

        const userGeoInfo = data?.viewer?.regionalInfo?.[0];
        setUserSessionGeoInfo(userGeoInfo);
    }
};

export { setUserRegionalInfo };
